module.exports = __webpack_public_path__ + "images/avatars/male/12.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/12.svg
// module id = V3H0
// module chunks = 151